<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        advanced
        :resource="$sdk.scheduledpickup"
        :primary-fields="[ 'template.account', 'template.carrier', 'template.sender', 'is_paused', 'date_from', 'date_to' ]"
        @ready="$refs.table.loadTable()"
        @apply="$refs.table.loadTable()"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
      >
        <SchedulePickupsTable
          ref="table"
          :filters="filters"
        />
      </el-card>
    </el-col>

    <SchedulePickupDialog
      v-if="isShowEditFormDialog"
      :schedule="schedule"
      @close="isShowEditFormDialog = false"
      @updatedSchedule="OnUpdatedSchedule"
      @reload="$refs.table.reload()"
      @ready="$refs.table.reload()"
    />
  </el-row>
</template>

<script>
import SchedulePickupsTable from '@/components/Application/Manage/SchedulePickups/SchedulePickupsTable'
import SchedulePickupDialog from '@/components/Application/Manage/SchedulePickup/SchedulePickupDialog'
import Filters from '@/components/Filters/Simplified'
import { CREATE } from '@/plugins/user'

export default {
  components: {
    SchedulePickupsTable,
    SchedulePickupDialog,
    Filters
  },
  data () {
    return {
      title: 'Scheduled Pickups',
      actions: [
        {
          hidden: this.$user.cannot(CREATE, this.$sdk.scheduledpickup),
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.schedule = {
              date_from: this.$moment(new Date()).format('YYYY-MM-DD')
            }
            this.isShowEditFormDialog = true
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => {
            this.$refs.table.reload()
          }
        }
      ],
      breadcrumb: {
        name: 'Scheduled Pickups',
        route: { name: 'manage-schedulepickups' }
      },
      isShowEditFormDialog: false,
      schedule: {},
      filters: []
    }
  },
  methods: {
    OnUpdatedSchedule (schedule) {
      this.$set(this, 'schedule', schedule)
      this.$refs.table.loadTable()
    }
  }
}
</script>
